import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiPlus,
  FiEdit,
  FiEye,
  FiCheckCircle,
  FiXCircle,
  FiUser,
  FiFileText,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function AgentDirectory() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [agents] = useState([
    {
      id: 1,
      agentId: "AGT-001",
      name: "Amit Patel",
      email: "amit@example.com",
      phone: "+91 9876543210",
      kycStatus: "Verified",
      bankStatus: "Verified",
      agreementStatus: "Uploaded",
      clientsCount: 24,
      status: "Active",
      onboardDate: "2024-01-01",
    },
    {
      id: 2,
      agentId: "AGT-002",
      name: "Sneha Reddy",
      email: "sneha@example.com",
      phone: "+91 9876543211",
      kycStatus: "Pending",
      bankStatus: "Verified",
      agreementStatus: "Pending",
      clientsCount: 0,
      status: "Pending",
      onboardDate: "2024-01-15",
    },
    {
      id: 3,
      agentId: "AGT-003",
      name: "Vikram Singh",
      email: "vikram@example.com",
      phone: "+91 9876543212",
      kycStatus: "Verified",
      bankStatus: "Verified",
      agreementStatus: "Uploaded",
      clientsCount: 18,
      status: "Active",
      onboardDate: "2023-12-10",
    },
  ]);

  const handleCreateAgent = () => {
    Swal.fire({
      title: "Onboard New Agent",
      html: `
        <input id="agentName" class="swal2-input" placeholder="Agent Name" required>
        <input id="agentEmail" class="swal2-input" type="email" placeholder="Email" required>
        <input id="agentPhone" class="swal2-input" placeholder="Phone" required>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Create Agent",
      confirmButtonColor: "#006e82",
    });
  };

  const handleApproveAgent = (agentId) => {
    Swal.fire({
      title: "Approve Agent?",
      text: "This agent will be activated.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
      confirmButtonColor: "#10b981",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Approved!", "Agent has been approved and activated.", "success");
      }
    });
  };

  const handleMapClients = (agentId) => {
    Swal.fire({
      title: "Map Clients to Agent",
      html: `
        <input id="clientIds" class="swal2-input" placeholder="Enter client IDs (comma-separated)" required>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Map Clients",
      confirmButtonColor: "#006e82",
    });
  };

  const filteredAgents = agents.filter((agent) => {
    const matchesSearch =
      agent.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      agent.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      agent.agentId.includes(searchTerm);
    const matchesStatus = statusFilter === "all" || agent.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredAgents.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredAgents.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                 <div className="content-page-header content-page-headersplit">
                <h5>Agent Directory</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/agents/directory">Agents</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Agent Directory
                  </li>
                </ol>
              </nav>
           
          
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Filters */} 
                <div className="row g-2 flex-grow-1">
                <div className="col-12 col-md-6">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by name, email, or agent ID..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="Active">Active</option>
                    <option value="Pending">Pending</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
                </div>
                <div className="ms-md-3 mt-3 mt-md-0">
                <button className="btn btn-primary" onClick={handleCreateAgent}>
                  Onboard Agent
                </button>
              </div>
              </div>
            </div>

            {/* Agents Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Agent ID</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>KYC Status</th>
                          <th>Agreement</th>
                          <th>Clients</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="9">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((agent) => (
                            <tr key={agent.id}>
                              <td style={{ fontWeight: "500" }}>{agent.agentId}</td>
                              <td style={{ fontWeight: "500" }}>{agent.name}</td>
                              <td>{agent.email}</td>
                              <td>{agent.phone}</td>
                              <td>
                                <span className={agent.kycStatus === "Verified" ? "badge-active" : "badge-pending"}>
                                  {agent.kycStatus}
                                </span>
                              </td>
                              <td>
                                <span className={agent.agreementStatus === "Uploaded" ? "badge-active" : "badge-pending"}>
                                  {agent.agreementStatus}
                                </span>
                              </td>
                              <td style={{ fontWeight: "600" }}>{agent.clientsCount}</td>
                              <td>
                                <span className={agent.status === "Active" ? "badge-active" : agent.status === "Pending" ? "badge-pending" : "badge-pending"}>
                                  {agent.status}
                                </span>
                              </td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table me-2"
                                    title="View Details"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </div>
                                  {agent.status === "Pending" && (
                                    <div
                                      className="delete-table me-2"
                                      onClick={() => handleApproveAgent(agent.agentId)}
                                      title="Approve Agent"
                                      style={{ cursor: "pointer", color: "#10b981" }}
                                    >
                                      <i className="fas fa-check-circle"></i>
                                    </div>
                                  )}
                                  <div
                                    className="delete-table"
                                    onClick={() => handleMapClients(agent.agentId)}
                                    title="Map Clients"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-user"></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
